module.exports = __webpack_public_path__ + "media/images/loading-8cef2bfa.gif";